<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('访客系统配置表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-button  class="query-banner-btn" type="primary" @click="searchQuery" icon="search">刷新</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="switchStatus" slot-scope="text,record">
          <a-switch checked-children="启用" un-checked-children="禁用" :checked="text==='0'?true:false"  :loading="record.isloading?true:false" @change="handleSwitchChange($event,record)"  />
        </span>
        <span slot="action" slot-scope="text,record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <visitor-config-modal ref="modalForm" @ok="modalFormOk"></visitor-config-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import VisitorConfigModal from './modules/VisitorConfigModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction } from '@/api/manage'
  export default {
    name: "BusVisitorConfigList",
    mixins:[JeecgListMixin],
    components: {
      VisitorConfigModal
    },
    data () {
      return {
        description: '访客系统配置表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'开关名称',
            align:"center",
            dataIndex: 'switchName'
          },
          {
            title:'开关编码',
            align:"center",
            dataIndex: 'switchCode'
          },
          {
            title:'开关状态',
            align:"center",
            dataIndex: 'switchStatus',
            scopedSlots: { customRender: 'switchStatus' }
          },
          {
            title:'开关备注',
            align:"center",
            dataIndex: 'notes'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/visitor/busVisitorConfig/list",
          delete: "/visitor/busVisitorConfig/delete",
          deleteBatch: "/visitor/busVisitorConfig/deleteBatch",
          exportXlsUrl: "/visitor/busVisitorConfig/exportXls",
          importExcelUrl: "visitor/busVisitorConfig/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      handleSwitchChange(event,record){
        this.$set(record,"isloading",true)
        let formData={
          id:record.id,
          switchStatus:event?"0":"1",
        }
        httpAction("/visitor/busVisitorConfig/edit",formData,"post").then((res)=>{
          if(res.success){
            this.$message.success(res.message);
            this.$set(record,"switchStatus",event?"0":"1")
          }else{
            this.$message.warning(event?"启用成功":"禁用成功");
          }
        }).finally(() => {
          this.$set(record,"isloading",false)
        })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  .query-banner-btn{
    margin-left: 12px;
  }
</style>